import type { Location } from 'modules/core/lib/navigation/types'

const commonApplicationDetailRoutes = {
  convertToEmployee: {
    level: 1, // TODO: This should be level 2.
    size: 'full',
    path: 'convert-to-employee',
  },
} as const

export const navigation = {
  path: 'recruitment',
  children: {
    jobs: {
      size: 'full',
      path: 'jobs',
      children: {
        requisitions: {
          size: 'full',
          path: 'requisitions',
          children: {
            new: {
              size: 'full',
              path: 'new',
            },
            requisitionDetail: {
              level: 1, // TODO: This should be level 2.
              size: 'full',
              path: ':requisition_id',
            },
          },
        },
        new: {
          size: 'full',
          path: 'new',
        },
        jobsId: {
          level: 1, // TODO: This should be level 2.
          path: ':jobId',
          children: {
            applications: {
              size: 'full',
              level: 1, // TODO: This should be level 2.
              path: 'applications',
              children: {
                new: {
                  level: 1, // TODO: This should be level 2.
                  size: 'full',
                  path: 'new',
                },
                newFromCv: {
                  level: 1, // TODO: This should be level 2.
                  size: 'full',
                  path: 'new-from-cv',
                },
                newEmployeeCandidate: {
                  level: 1, // TODO: This should be level 2.
                  size: 'full',
                  path: 'new-employee-candidate',
                },
                applicationDetail: {
                  level: 1, // TODO: This should be level 2.
                  size: 'full',
                  path: ':application_id',
                  children: {
                    index: {
                      level: 1, // TODO: This should be level 2.
                      size: 'full',
                      path: '',
                      children: commonApplicationDetailRoutes,
                    },
                    messages: {
                      level: 1, // TODO: This should be level 2.
                      size: 'full',
                      path: 'messages',
                      children: commonApplicationDetailRoutes,
                    },
                    notes: {
                      level: 1, // TODO: This should be level 2.
                      size: 'full',
                      path: 'notes',
                      children: commonApplicationDetailRoutes,
                    },
                    feedback: {
                      level: 1, // TODO: This should be level 2.
                      size: 'full',
                      path: 'feedback',
                    },
                    files: {
                      level: 1, // TODO: This should be level 2.
                      size: 'full',
                      path: 'files',
                      children: commonApplicationDetailRoutes,
                    },
                    otherInfo: {
                      level: 1,
                      size: 'full',
                      path: 'other-info',
                      children: commonApplicationDetailRoutes,
                    },
                    offerLetter: {
                      level: 1, // TODO: This should be level 2.
                      size: 'full',
                      path: 'offer-letters/:offer_letter_id',
                    },
                  },
                },
              },
            },
            /**
             * DO NOT USE. It will be removed.
             *
             * This is only kept to redirect to the new applications view.
             * You can check out the redirection in the ats/routes.tsx file.
             *
             * @deprecated
             */
            candidates: {
              size: 'full',
              level: 1,
              path: 'candidates/*',
            },
            standardPortals: {
              level: 2,
              path: 'standard-portals',
            },
            premiumPortals: {
              level: 2,
              path: 'premium-portals',
            },
            marketplace: {
              level: 2,
              path: 'marketplace',
            },
            settings: {
              level: 1,
              path: 'settings',
            },
          },
        },
        importJobPostings: {
          path: 'import/*',
          size: 'full',
        },
      },
    },

    candidates: {
      path: 'candidates',
      size: 'full',
      children: {
        new: {
          size: 'full',
          path: 'new',
        },
        import: {
          size: 'full',
          path: 'import',
        },
        importCandidates: {
          path: 'import-candidates/*',
          size: 'full',
          level: 2,
        },
        newEmployeeCandidate: {
          size: 'full',
          path: 'new-employee-candidate',
        },
        id: {
          path: ':id',
          level: 1, // TODO: This should be level 2.
          children: {
            timeoffApprovalRequest: {
              path: 'approval-request/:leaveId',
            },
            applications: {
              level: 1, // TODO: This should be level 2.
              size: 'full',
              path: 'applications',
            },
            cv: {
              level: 1, // TODO: This should be level 2.
              size: 'full',
              path: 'cv',
            },
            files: {
              level: 1, // TODO: This should be level 2.
              size: 'full',
              path: 'files',
            },
            notes: {
              level: 1, // TODO: This should be level 2.
              size: 'full',
              path: 'notes',
            },
          },
        },
      },
    },
    messages: {
      path: 'messages',
      size: 'full',
      children: {
        conversation: {
          level: 1,
          size: 'full',
          path: ':conversation_id',
        },
      },
    },
    openPositions: {
      path: 'open-positions',
      size: 'full',
    },
    insights: {
      path: 'insights',
      size: 'full',
    },
    purchaseRequests: {
      path: 'purchase-requests',
      size: 'full',
      children: {
        detail: {
          level: 2,
          size: 'full',
          path: ':orderId',
        },
      },
    },
    hiringPlan: {
      path: 'hiring-plan',
      size: 'full',
      children: {
        vacancies: {
          path: 'vacancies',
          size: 'full',
          children: {
            new: {
              size: 'full',
              path: 'new',
            },
            vacancyDetail: {
              level: 1,
              size: 'full',
              path: ':vacancy_id',
            },
            newJob: {
              size: 'full',
              path: 'new-job',
            },
          },
        },
        requisitions: {
          path: 'requisitions',
          size: 'full',
          children: {
            new: {
              size: 'full',
              path: 'new',
            },
          },
        },
      },
    },
  },
} as const satisfies Location
